import Timeout from "@/js/component/Timeout";
import UiInput from "@/react/story/components/ui/UiInput";
import { useItems } from "@/react/story/providers/ItemsContext";
import type { Color } from "@/react/story/types";
import InitUtils from "@/react/story/utils/InitUtils";
import { useRef, useState } from "react";

type Props = {
    color: Color | null | undefined;
    onChange: (color: Color | null) => void;
}

export default function UiColorPicker(props: Props) {
    const Items = useItems();

    const ti = useRef(new Timeout(500));

    const [ color, setColor ] = useState<Color | null>(props.color ?? null);

    const suggestions = InitUtils
        .findColors(Items.routes.map(r => r.page))
        .slice(0, 10);

    const saveColor = (color: Color | null) => {
        setColor(color);
        ti.current.run(() => props.onChange(color));
    };

    const toggle = () => {
        saveColor(color ? null : "#000000");
    };

    return (
        <div className="input-group">
            {color ? (
                <>
                    <UiInput
                        type="color"
                        className="form-control-color"
                        defaultValue={color}
                        onChange={color => saveColor(color)}
                    />
                    {suggestions.length > 0 ? (
                        <>
                            <button className="btn btn-secondary dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                <span className="bi-magic" />
                            </button>
                            <ul className="dropdown-menu">
                                {suggestions.map(color => (
                                    <li key={color}>
                                        <button className="dropdown-item d-flex gap-1" onClick={() => saveColor(color)}>
                                            <span className="bi-square-fill" style={{ color }} />
                                            <span>{color}</span>
                                        </button>
                                    </li>
                                ))}
                            </ul>
                        </>
                    ) : null}
                </>
            ) : null}
            <button
                type="button"
                className={`btn btn-outline-${color ? "danger" : "success"}`}
                onClick={toggle}
            >
                <span className={color ? "bi-trash" : "bi-gear"}></span>
            </button>
        </div>
    );
}
